

import React, { useEffect, useState } from 'react';

import { DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton } from "components";

import { convertArrayToDropdownArrayFormat, getTotalCountFromHeader, isArrayNotEmpty, isFunction, isNumberOrStringValid, isObjectEmpty } from 'functions';

import 'assets/scss/billingPortal/modules/accountControl.scss';
import { Dropdown } from "components";
import useDropdownLists from './hooks/useDropdownLists';
import { useCustomSelector } from 'hooks';
import useModals from './hooks/useModals';
import useAlertMessage from './hooks/useAlertMessage';

import ic_update_expiry_date from "assets/images/ic_update_expiry_date.svg";
import ic_suspend_all from "assets/images/ic_suspend_trial.svg";
import ic_toggle from "assets/images/ic_toggle.svg";
import ic_active_all from "assets/images/ic_active_trial.svg";
import ic_reset_payment_due_date from "assets/images/ic_reset_payment_due_date.svg";
import ic_update_payment_due_date from "assets/images/ic_update_payment_due_date.svg";
import ic_update from 'assets/images/ic_update.svg';
import ic_update_billing_tag from 'assets/images/ic_update_billing_tag.svg';
import ic_update_dealer_code from 'assets/images/ic_update_dealer_code.svg';
import ic_delete_invoices from 'assets/images/ic_delete_invoices.svg';
import ic_update_package from 'assets/images/ic_update_package.svg';

import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { useColumns } from './hooks/useColumns';
import { Toaster } from 'components/notification/Toaster';
import { MultiFilters } from "components/filters/MultiFilters";



export default function AccountControl(props) {

    const [selectedRows, setSelectedRows] = useState();

	let { 
		comList, comListHeaders,
		getComList_requesting,

        getAllComList_requesting,
        
        updateTrialStatus_requesting,
        suspendCOM_requesting, activateCOM_requesting,
        removeSuspendDate_requesting,

        isUpdateSuccessful
	} = useCustomSelector("accountControl");

    const { userPermissions } = useCustomSelector("userManagementReducers");
	const { getComList } = useAccountControlActions();
    const { updateTrialStatus, suspendCOM, activateCOM, removeSuspendDate } = useAccountControlActions();
    const [isMultipleToggling, setIsMultipleToggling] = useState();

    useEffect(() => {
        if (!updateTrialStatus_requesting && isMultipleToggling) setIsMultipleToggling(false);
    }, [updateTrialStatus_requesting])

    const {
        alertMsgDisplay
    } = useAlertMessage(props);

    const {
        updateExpiryDateModal, updatePaymentDueDateModal, resetPaymentDueDateModal, updateDealerCodeModal, updatePackageModal,
        updateBillingTagModal, deleteCOMModal, revertDeletedCOMModal, setSuspendDateModal,

        setIsVisible_updateExpiryDate, setIsVisible_updatePaymentDueDate, setIsVisible_resetPaymentDueDate,
        setIsVisible_updateDealerCode, setIsVisible_updateBillingTag, setIsVisible_updatePackage,
        setIsVisible_deleteCOM, setIsVisible_revertDeletedCOM, setIsVisible_setSuspendDate
    } = useModals(selectedRows);

    const {
        comIdList, companyNameList,
    } = useDropdownLists();

    const columns = useColumns();

    function rowSelectionCheck(callback = () => {}) {
        if (isArrayNotEmpty(selectedRows)) {
            callback();
        }
        else {
            Toaster({
                type: "info",
                msg: "Please selected at least 1 row"
            })
        }
    }

    return (
        <div className={"account-control"}>
            {/* Update Expiry Date Modals */}
            {updateExpiryDateModal}

            {/* Update Payment Due Date Modal */}
            {updatePaymentDueDateModal}

            {/* Reset Payment Due Date Modal */}
            {resetPaymentDueDateModal}

            {/* Update Dealer Code Modal */}
            {updateDealerCodeModal}

            {/* Update Billing Tag Modal */}
            {updateBillingTagModal}

            {/* Delete COM Modal */}
            {deleteCOMModal}

            {/* Revert Deleted COM Modal */}
            {revertDeletedCOMModal}

            {/* Update Package */}
            {updatePackageModal}

            {/* Suspend Date Modal */}
            {setSuspendDateModal}
            
            {/* Page */}
            <DashboardLayout
                headerTitle={"COM Account Control"}

                bodyClassName={"account-control__body"}
                body={(
                    <GeneralTable
                        className={"body__table"}
                        columns={columns}
                        data={userPermissions?.Internal_AccControl_View? comList:[]}
                        defaultFilter={{
                            isSuspended: "all",
                            isTrial: "all"
                        }}
                        getTableData={getComList}

                        isTableRefreshRequired={isUpdateSuccessful}

                        onRowSelectionChange={setSelectedRows}

                        topOuterTableHeader={() => alertMsgDisplay}
                        outerTableHeader={() => {
                            return (
                                <div className={"table__header d-flex align-items-center justify-content-between "}>
                                    <div className={"header__title tableHeaderTitle "}>
                                        List
                                    </div>
                                
                                    <div className={"header__action d-flex align-items-center"}>
                                        <div className={"action__main-action-wrapper"}>
                                            <Button
                                                className={"main-action-wrapper__main-action tableHeaderButtonPadding d-flex align-items-center"}
                                                handleOnClick={() => rowSelectionCheck(() => {
                                                    selectedRows.map((details) => {
                                                        if (details?.ComId) {
                                                            updateTrialStatus(details?.ComId, details?.Trial);
                                                            setIsMultipleToggling(true);
                                                        }
                                                        else {
                                                            Toaster({
                                                                type: "error",
                                                                msg: "COM ID required"
                                                            })
                                                        }
                                                    })
                                                })}

                                                isDisabled={!(userPermissions?.Internal_AccControl_TrialStatusUpdate)}
                                                isLoading={updateTrialStatus_requesting && isMultipleToggling}
                                                isDecoration_primaryTransparent isSpinnerColorPrimary
                                            >
                                                <>
                                                    <img
                                                        className={"main-action__icon"}
                                                        src={ic_toggle}
                                                    />

                                                    <span className={"main-action__text tableHeaderButtonText "}>Toggle</span>
                                                </>
                                            </Button>
                                        </div>

                                        <SubmenuTooltip
                                            className={"action__more-actions-wrapper"}
                                            menuItems={[
                                                {
                                                    icon: ic_update_expiry_date,
                                                    label: "Update Expiry Date",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_TrialExpireDateUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_updateExpiryDate(true)),
                                                },
                                                {
                                                    icon: ic_update_payment_due_date,
                                                    label: "Update Payment Due",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_PaymentDueUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_updatePaymentDueDate(true)),
                                                },
                                                {
                                                    icon: ic_reset_payment_due_date,
                                                    label: "Reset Payment Due",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_PaymentDueUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_resetPaymentDueDate(true)),
                                                },
                                                {
                                                    icon: ic_update_dealer_code,
                                                    label: "Update Dealer Code",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_DealerCodeUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_updateDealerCode(true)),
                                                },
                                                {
                                                    icon: ic_update_billing_tag,
                                                    label: "Update Billing Tag",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_BillingTagUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_updateBillingTag(true)),
                                                },
                                                {
                                                    icon: ic_update_package,
                                                    label: "Update Package",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_SubsPackageUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_updatePackage(true)),
                                                },
                                                {
                                                    icon: ic_delete_invoices,
                                                    label: "Delete COM",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_DeleteComUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_deleteCOM(true)),
                                                },
                                                {
                                                    icon: ic_delete_invoices,
                                                    label: "Revert Delete COM",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_DeleteComUpdate),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_revertDeletedCOM(true)),
                                                },
                                                {
                                                    icon: ic_active_all,
                                                    label: "Activate COM",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_ComStatusActivate),
                                                    onClick: () => rowSelectionCheck(() => {
                                                        selectedRows.map((details) => {
                                                            if (details?.ComId) {
                                                                activateCOM(details?.ComId);
                                                            }
                                                            else {
                                                                Toaster({
                                                                    type: "error",
                                                                    msg: "COM ID required"
                                                                })
                                                            }
                                                        })
                                                    }),
                                                    isLoading: activateCOM_requesting,
                                                },
                                                {
                                                    icon: ic_suspend_all,
                                                    label: "Suspend COM",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_ComStatusSuspend),
                                                    onClick: () => { 
                                                        rowSelectionCheck(() => {
                                                            selectedRows.map((details) => {
                                                                if (details?.ComId) {
                                                                    suspendCOM(details?.ComId);
                                                                }
                                                                else {
                                                                    Toaster({
                                                                        type: "error",
                                                                        msg: "COM ID required"
                                                                    })
                                                                }
                                                            })
                                                        });
                                                    },
                                                    isLoading: suspendCOM_requesting
                                                },
                                                {
                                                    icon: ic_update_expiry_date,
                                                    label: "Set Suspend Date",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_ComStatusSuspend),
                                                    onClick: () => rowSelectionCheck(() => setIsVisible_setSuspendDate(true)),
                                                },
                                                {
                                                    icon: ic_update_expiry_date,
                                                    label: "Remove Suspend Date",
                                                    isDisabled: !(userPermissions?.Internal_AccControl_ComStatusSuspend),
                                                    onClick: () => rowSelectionCheck(() => {
                                                        selectedRows.map((details) => {
                                                            if (details?.ComId) {
                                                                removeSuspendDate(details?.ComId);
                                                            }
                                                            else {
                                                                Toaster({
                                                                    type: "error",
                                                                    msg: "COM ID required"
                                                                })
                                                            }
                                                        })
                                                    }),
                                                    isLoading: removeSuspendDate_requesting,
                                                },
                                            ]}
                                        >
                                            <MoreButton
                                                className={"more-actions-wrapper__more-actions"}
                                                iconClassName={"more-actions__icon"}
                                            />
                                        </SubmenuTooltip>
                                    </div>
                                </div>
                            );
                        }}

                        bottomOuterTableHeader={(outerTableHeader_props) => {
                            const {
                                filterOptions, setFilterOptions
                            } = outerTableHeader_props;

                            return (
                                <MultiFilters
                                    defaultFilterOption={{
                                        label: "COM ID", 
                                        propertyName: "comId",
                                        placeholder: "Select COM ID",
                                        options: comIdList,
                                        inputType: "dropdown",
                                        isInputDigitOnly: true
                                    }}
                                    filterOptions={[
                                        {
                                            label: "COM ID", 
                                            propertyName: "comId",
                                            placeholder: "Select COM ID",
                                            options: comIdList,
                                            inputType: "dropdown",
                                            isInputDigitOnly: true
                                        },
                                        {
                                            label: "Company Name", 
                                            propertyName: "comName",
                                            placeholder: "Select Company Name",
                                            options: companyNameList,
                                            inputType: "dropdown"
                                        },
                                        {
                                            label: "Billing Tag", 
                                            propertyName: "billingTag",
                                            placeholder: "Search Billing Tag",
                                            inputType: "search"
                                        },
                                        {
                                            label: "Dealer Code", 
                                            propertyName: "dealerCode",
                                            placeholder: "Search Dealer Code",
                                            inputType: "search"
                                        },
                                        {
                                            label: "Is Deleted", 
                                            propertyName: "deleted",
                                            options: convertArrayToDropdownArrayFormat([
                                                "Yes",
                                                "No"
                                            ]),
                                            inputType: "dropdown"
                                        },
                                        {
                                            label: "Is Trial", 
                                            propertyName: "isTrial",
                                            options:convertArrayToDropdownArrayFormat([
                                                "All",
                                                "Yes",
                                                "No"
                                            ]),
                                            inputType: "dropdown"
                                        },
                                        {
                                            label: "Is Suspended", 
                                            propertyName: "isSuspended",
                                            options:convertArrayToDropdownArrayFormat([
                                                "All",
                                                "Yes",
                                                "No"
                                            ]),
                                            inputType: "dropdown"
                                        },
                                        {
                                            label: "Suspend Date", 
                                            propertyName: "suspendDatePreset",
                                            placeholder: "Select Suspend Date",
                                            options:convertArrayToDropdownArrayFormat([
                                                "Preset Only",
                                                "No Preset"
                                            ]),
                                            inputType: "dropdown"
                                        },
                                    ]}
                                    dropdownPlaceholder={"Select Filter"}
                                    onApplyFilter={(inputFilters) => {
                                        setFilterOptions(isObjectEmpty(inputFilters)? {
                                            isTrial: "all",
                                            isSuspended: "all",
                                        }: { ...filterOptions, ...inputFilters});
                                    }}
                                />
                            );
                        }}

                        isExpanderRequired

                        isTableDataLoading={getComList_requesting}

                        isUsingPagination
                        totalRecords={getTotalCountFromHeader(comListHeaders)}

                        isColumnResizeable
                        isTableOddRowsDarken
                        isCheckboxRequired
                        isCheckboxColumnFirst isAllColumnWidthEqual
                    />
                )}
            />
        </div>
    );
}